import * as Types from '../../../../../generated/types';

import { gql } from '@apollo/client';
export type ImpactGroupFieldsFragment = (
  { __typename?: 'ImpactGroupTemplate' }
  & Pick<Types.ImpactGroupTemplate, 'rowId' | 'label' | 'slug' | 'description' | 'notificationMessage' | 'severity' | 'scope' | 'active' | 'actionUrl' | 'createdBy' | 'updatedBy' | 'templateExpiresAt' | 'createdAt' | 'updatedAt'>
);

export type ImpactGroupAssignmentFieldsFragment = (
  { __typename?: 'ImpactGroupAssignment' }
  & Pick<Types.ImpactGroupAssignment, 'id' | 'accountId' | 'userId' | 'impactGroupId' | 'assignedBy' | 'assignedAt' | 'assignmentExpiresAt' | 'dismissedAt' | 'dynamicMessageContent'>
);

export const ImpactGroupFieldsFragmentDoc = gql`
    fragment ImpactGroupFields on ImpactGroupTemplate {
  rowId
  label
  slug
  description
  notificationMessage
  severity
  scope
  active
  actionUrl
  createdBy
  updatedBy
  templateExpiresAt
  createdAt
  updatedAt
}
    `;
export const ImpactGroupAssignmentFieldsFragmentDoc = gql`
    fragment ImpactGroupAssignmentFields on ImpactGroupAssignment {
  id
  accountId
  userId
  impactGroupId
  assignedBy
  assignedAt
  assignmentExpiresAt
  dismissedAt
  dynamicMessageContent
}
    `;